module.exports = __webpack_public_path__ + "img/map_pin_home4.284be9c2.svg";